import type React from 'react';
import type { BaseAdConfig } from 'interfaces/ads/Ad';
import { AdsCenteredDiv, InStreamAd } from './Styles';
import AdSlotToggle from './AdSlotToggle';

const HomePageSimpleInStream: React.FC<BaseAdConfig> = ({ id }: BaseAdConfig) => (
  <AdsCenteredDiv>
    <InStreamAd className='simple-homepage'>
      <AdSlotToggle
        placementName='Homepage-SimpleInStream'
        index={id + 1}
        slotId={`HomepageSimpleInStream${id}`}
      />
    </InStreamAd>
  </AdsCenteredDiv>
);

export default HomePageSimpleInStream;
